// extracted by mini-css-extract-plugin
export default {"inputTooltip":"Tooltip_inputTooltip--RN9"};